var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collapse" },
    [
      _c(
        "div",
        { staticClass: "trigger is-flex is-align-items-center" },
        [
          _vm._t("trigger"),
          _vm._v(" "),
          _c("div", { staticClass: "ml-auto" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "indicator pointer",
              on: {
                click: function ($event) {
                  return _vm.$emit("input", !_vm.value)
                },
              },
            },
            [
              _vm.value
                ? _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "chevron-up"] },
                  })
                : _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "chevron-down"] },
                  }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value,
                expression: "value",
              },
            ],
            staticClass: "collapse-content",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }